// extracted by mini-css-extract-plugin
export default {"wrapper":"DeleteEventModal_wrapper__1Qlwh","radioWrapper":"DeleteEventModal_radioWrapper__2d81r","radioButton":"DeleteEventModal_radioButton__xHIYP"};